import PropTypes from 'prop-types'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { NumericFormat } from 'react-number-format'
import Precios from '../reutilizables/precios/Precios'
import styles from './PresupuestoForm.module.css'

const PresupuestoFormItemList = ({ item, idEstado, onDelete, canAdministrate }) => {
  const [clicked] = useState(false)

  return (
    <div className={styles.itemContenedor}>
      <div className={styles.itemFila}>
        <div className={styles.itemCelda}>{item.descripcion}</div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaCentro}`}>
          <NumericFormat
            value={item.cantidad}
            displayType={'text'}
            thousandSeparator={false}
            decimalSeparator={'.'}
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`}>
          <Precios
            precio={item.precio}
            monedaSimbolo={item.monedaSimbolo}
            unidadMedida={item.unidadMedida}
          />
        </div>
        <div className={styles.itemCelda}>{item.unidadMedida}</div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`}>
          <Precios precio={item.total} monedaSimbolo={item.monedaSimbolo} />
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`}>
          {item.alicuota ?? 0}%
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`}>
          {idEstado === 0 && canAdministrate && (
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => onDelete(item.idPresupuestoItem)}
            >
              {clicked ? <Spinner animation="border" role="status" size="sm" /> : 'Quitar'}
            </button>
          )}
        </div>
      </div>

      <div className={styles.itemCard}>
        <div className={styles.itemCardTitulo}>{item.descripcion}</div>
        <div className={styles.itemCardFila}>
          <span className={styles.itemCardLabel}>Cantidad</span>
          <span className={styles.itemCardValor}>
            <NumericFormat
              value={item.cantidad}
              displayType={'text'}
              thousandSeparator={false}
              decimalSeparator={'.'}
              fixedDecimalScale={true}
              decimalScale={2}
            />
          </span>
        </div>
        <div className={styles.itemCardFila}>
          <span className={styles.itemCardLabel}>Precio</span>
          <span className={styles.itemCardValor}>
            <Precios precio={item.precio} monedaSimbolo={item.monedaSimbolo} />
          </span>
        </div>
        <div className={styles.itemCardFila}>
          <span className={styles.itemCardLabel}>Unidad</span>
          <span className={styles.itemCardValor}>{item.unidadMedida}</span>
        </div>
        <div className={styles.itemCardFila}>
          <span className={styles.itemCardLabel}>Total</span>
          <span className={styles.itemCardValor}>
            <Precios precio={item.total} monedaSimbolo={item.monedaSimbolo} />
          </span>
        </div>
        <div className={styles.itemCardFila}>
          <span className={styles.itemCardLabel}>% IVA</span>
          <span className={styles.itemCardValor}>{item.alicuota ?? 0}%</span>
        </div>
        {idEstado === 0 && canAdministrate && (
          <div className={styles.itemCardAcciones}>
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => onDelete(item.idPresupuestoItem)}
            >
              {clicked ? <Spinner animation="border" role="status" size="sm" /> : 'Quitar'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

PresupuestoFormItemList.propTypes = {
  item: PropTypes.shape({
    descripcion: PropTypes.string.isRequired,
    cantidad: PropTypes.number.isRequired,
    precio: PropTypes.number.isRequired,
    monedaSimbolo: PropTypes.string,
    unidadMedida: PropTypes.string,
    total: PropTypes.number.isRequired,
    idPresupuestoItem: PropTypes.number.isRequired,
    alicuota: PropTypes.number
  }).isRequired,
  idEstado: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  canAdministrate: PropTypes.bool.isRequired
}

export default PresupuestoFormItemList
